import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TextReplaceService {

  private replacements = new Map<string, string>([
    ['sócios', 'torcedores'],
    ['sócio', 'torcedor'],
    ['planos', 'passaportes'],
    ['plano', 'passaporte']
  ]);

  isEnabled(): boolean {
    return JSON.parse(localStorage.getItem('enableTextReplace') || 'false');
  }

  replace(text: string): string {
    if (!this.isEnabled() || !text) return text;

    let result = text;

    this.replacements.forEach((value, key) => {
      const regex = new RegExp(`\\b${this.escape(key)}\\b`, 'gi');
      result = result.replace(regex, this.applyCase(result, value));
    });

    return result;
  }

  private escape(text: string): string {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  private applyCase(source: string, target: string): string {
    // se o source está todo em maiúsculo → retorna value.toUpperCase()
    if (source.toUpperCase() === source) return target.toUpperCase();

    // se o source é Capitalizado → retorna capitalizado
    if (source[0] === source[0].toUpperCase())
      return target[0].toUpperCase() + target.slice(1);

    // padrão → minúsculo
    return target.toLowerCase();
  }
}

